import { ActionTree } from "vuex";
import { CategoryState } from "@/store/category/type";
import { RootState } from "@/store/type";
import Api from "@/api/Api";
import { CategoryMutations } from "@/store/category/mutations";
import { Category } from "@/models/category";
import icons from "@/utils/icons";
import { i18n } from "vue-lang-router";

export const actions: ActionTree<CategoryState, RootState> = {
  getCategoryTree({ commit, state }): Promise<Category> | Category {
    commit(CategoryMutations.SET_CATEGORY_TREE, null);
    return Api.category.getTree()
      .then((data: Category) => {
        if (data.children && data.children.length > 0) {
          data.children.forEach((subcat) => {
            if (subcat.children) {
              subcat.children.sort(function (a, b) {
                return a.label.localeCompare(b.label);
              });
            }
          });
        }
        commit(CategoryMutations.SET_CATEGORY_TREE, data);
        return data;
      }).catch((e) => {
        console.error(e);
        /*  if (e.status === 404) {
            Router.push("/404");
          }*/
        this.dispatch("sendNotification", {
          type: "danger",
          message: i18n.t("errors.server.access"),
          icon: icons.error,
        });
        return e;
      });

  },
};